<nav ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false">
  <ng-container ngbNavItem>
    <a ngbNavLink>{{ 'Power data' | translate }} </a>
    <ng-template ngbNavContent>
      <ng-template  *ngTemplateOutlet="measurementsTable">

      </ng-template>
    </ng-template>
  </ng-container>
</nav>

<div [ngbNavOutlet]="nav" class="mt-2">

</div>

<ng-template #measurementsTable >
  <table id="measurementsTable" class="table table-sm" *ngIf="tableData$ | async as tableData">
    <thead>
      <tr>
<!--         <th>{{'Tag' | translate}}</th> -->
        <th>{{'Description' | translate}}</th>
        <th class="tagvalue">{{'Value' | translate}}</th>
        <th>{{'Unit' | translate}}</th>
        <th>{{'Timestamp' | translate}}</th>
      </tr>
    </thead>
    <tbody style="overflow-y: visible">

        <ng-container *ngFor="let row of tableData.rows">
          <ng-container *ngIf="row.valmetDnaWrappedTagsResult.tagFound; else tagNotFoundBlock">
            <tr>
<!--               <td>
                {{ row.valmetDnaWrappedTagsResult.tag.TagName }}
              </td> -->
              <ng-template #tagInfo>{{ row.valmetDnaWrappedTagsResult.requestedTag.fullTag }}</ng-template>
              <td [ngbTooltip]="tagInfo">
                {{ row.valmetDnaWrappedTagsResult.tag.Description }}
              </td>
              <td class="tagvalue">
                {{ row.formattedValue ? row.formattedValue : ('Value not found' | translate) }}
              </td>
              <td>
                {{ row.valmetDnaWrappedTagsResult.tag.Unit }}
              </td>
              <td>
                {{ row.valmetDnaValue?.ts | qmDateDistance }}
              </td>
            </tr>
          </ng-container>

          <ng-template #tagNotFoundBlock>
            <tr>
<!--               <td>
                {{ row.valmetDnaWrappedTagsResult.requestedTag.fullTag }}
              </td> -->
              <td class="text-warning">
                {{ 'Tag was not found' | translate }}
              </td>
              <td>
                -
              </td>
              <td>
                -
              </td>
              <td>
                -
              </td>
            </tr>
          </ng-template>

        </ng-container>

        <tr>
<!--           <td></td> -->
          <td>
            {{ 'Total' | translate }}
          </td>
          <td>
            {{ tableData.totalValueSum }}
          </td>
          <td></td>
          <td></td>
        </tr>
    </tbody>
  </table>
  <!-- FIXME: message appears strangely when table is shown -->
  <ng-container *qmLoading="loading;config:loadingConfig"></ng-container>
</ng-template>
